
import React from 'react';
import { NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate } from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowInventoryCalculationCutbackEditModalStore')
@observer
class NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowInventoryCalculationCutbackEditModal;
